import type { IMetaAnniversary, IMetaOnboarding, TCompanyActivity } from "@/types"
import { api } from "./api"
import { generateSetupActivity } from "./utils"

export * from "./activities"
export * from "./api"
export * from "./auth"
export * from "./coffee"
export * from "./common"
export * from "./company"
export * from "./people"
export * from "./radio"
export * from "./recognition"
export * from "./reimbursement"
export * from "./slack"
export * from "./surveys"
export * from "./types"
export * from "./utils"
export * from "./vacation"

// Other APIs
export const anniversaryAPI = {
  ...generateSetupActivity<TCompanyActivity<IMetaAnniversary>>("/anniversary"),
  test: () => api.post("/anniversary/test").then((res) => res.data),
  editUser: (userId: string, data: { birthday?: number | null; dtstart?: number | null }) =>
    api.post(`/anniversary/edit/${userId}`, data).then((res) => res.data),
}
export const onboardingSetupAPI = {
  ...generateSetupActivity<TCompanyActivity<IMetaOnboarding>>("/survey/setup/onboarding"),
  test: () => api.post("/onboarding/test").then((res) => res.data),
}
export const pulseSetupAPI = generateSetupActivity("/survey/setup/pulse")
export const surveySetupAPI = generateSetupActivity("/survey/setup/survey")
export const feedbackSetupAPI = generateSetupActivity("/survey/setup/feedback")

export const radioSetupAPI = {
  ...generateSetupActivity("/radio/setup"),
  test: () => api.post("/radio/setup/test").then((res) => res.data),
}
